import { IconName } from '@rtr-factory/utils/icons';

export type IconPosition = 'left' | 'right' | '';

export interface ChipIcon {
  icon: IconName;
  position: IconPosition;
}

export const chainIcon: ChipIcon = {
  icon: 'prompt-chain',
  position: 'left',
};

export const uncategorizedIcon: ChipIcon = {
  icon: 'context-menue-sm',
  position: 'left',
};

export const noIcon: ChipIcon = {
  icon: '' as IconName,
  position: '',
};
